// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3AIF2","title":"Images90_title__3fIr9","images":"Images90_images__Us3RD"};